const FOOTER_LINKS = {
  '影视分类': ['电影', '电视剧', '综艺', '动漫', '纪录片', '短剧'],
  '热门推荐': ['排行榜', '新片速递', '高分精选', '热播剧集', '经典回顾', '专题合集'],
  '服务支持': ['常见问答', '联系我们', '关于我们', '移动客户端', '使用帮助', '意见反馈'],
};

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6 py-14 md:py-16">
        {/* Top row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <span className="text-2xl font-bold font-heading text-primary-400">番茄影视</span>
            <p className="text-sm text-background-300 mt-3 leading-relaxed">
              番茄影视大全致力于打造一站式高清影视平台，覆盖电影、电视剧、综艺、动漫等全类型片库，免费在线观看，流畅不卡顿，满足全家观影需求。
            </p>
          </div>

          {/* Link groups */}
          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-background-50 mb-3 font-heading">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link}>
                    <a
                      href="#hero"
                      className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Partners */}
        <div className="border-t border-background-800 pt-8 mb-8">
          <h4 className="text-sm font-semibold text-background-50 mb-3 font-heading">合作伙伴</h4>
          <p className="text-xs text-background-500">诚邀优质内容方与平台加盟合作，携手打造更丰富的影视生态</p>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 番茄影视大全. 本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-background-500 hover:text-primary-400 transition-colors cursor-pointer">
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}